import React from 'react';
import MobileFilterAccordion from '@components/MobileFilterAccordion/MobileFilterAccordion';
import { Colors } from '@components/Colors';
import {
  FilterContainer,
  FilterContainerItem,
  StyledFilterLabel,
  StyledFilterSpan,
  StyledAccordionFilterText,
  StyledPlaceholderCloudImage,
  AccordionColorsContainer,
  StyledWrapper,
} from '@components/SelectFilterMobile/SelectFilterMobile.styles';
import { SelectFilterTag } from '@components/SelectFilterTag';
import { SelectFilterOptions } from '@components/SelectFilter';

export interface SelectProps<T> {
  className?: string;
  showIcon?: boolean;
  selectedOptions: string[];
  options: SelectFilterOptions;
  selectType: string;
  selectLabel: string;
  padding?: string;
  onClickedOption: (selectedOptions: string[]) => void;
}

export const SelectFilterMobile = <T extends string>({
  showIcon = false,
  options,
  selectedOptions,
  selectType,
  selectLabel,
  padding,
  onClickedOption,
}: SelectProps<T>) => {
  const handleChange = (name: string, isChecked: boolean) => {
    if (isChecked) {
      selectedOptions = [...selectedOptions, name];
    } else {
      selectedOptions = selectedOptions.filter((item) => item !== name);
    }
    onClickedOption(selectedOptions);
  };

  return (
    <MobileFilterAccordion headerText={selectLabel} padding={padding} style={{ paddingTop: '18px', paddingBottom: '18px' }}>
      <FilterContainer>
        {selectType === 'color' ? (
          <>
            <AccordionColorsContainer>
              <Colors
                options={options}
                selectedOptions={selectedOptions}
                onClickedColor={(selectedColors) => {
                  onClickedOption(selectedColors);
                }}
              />
            </AccordionColorsContainer>
          </>
        ) : (
          <>
            {options.map((option, index) => (
              <FilterContainerItem key={index} checked={selectedOptions.some((item) => item === option.value)}>
                <StyledFilterLabel>
                  <input
                    type="checkbox"
                    checked={selectedOptions.some((item) => item === option.value)}
                    value={option.value}
                    onChange={(event) => {
                      handleChange(option.value, event.currentTarget.checked);
                    }}
                  />
                  <StyledFilterSpan className="checkmark"></StyledFilterSpan>
                  <StyledWrapper>
                    <StyledAccordionFilterText left={'55'} textAlign="left" variant="caption" color="neutra6" tagName="p">
                      {option.name}
                    </StyledAccordionFilterText>
                    {option.tag ? <SelectFilterTag value={option.tag} /> : null}
                  </StyledWrapper>
                  {showIcon ? (
                    <StyledPlaceholderCloudImage
                      src={option.value == 'aloha' ? 'wedding-website-gallery/single.svg' : 'wedding-website-gallery/multi.svg'}
                      alt=""
                      width="100%"
                      isMainSrcShown={true}
                    />
                  ) : null}
                </StyledFilterLabel>
              </FilterContainerItem>
            ))}
          </>
        )}
      </FilterContainer>
    </MobileFilterAccordion>
  );
};
